








import { FitIcon } from '@tencent/wphk-ui';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    FitIcon,
  },
})
export default class FitPicker extends Vue {
  @Prop({ default: false }) public line!: boolean;
  @Prop({ default: false }) public dot!: boolean;
}
